<template>
  <PageLayout
    :page-title="pageTitle"
    :show-breadcrumbs="false"
    :show-page-header="false"
    :breadcrumb-items="breadcrumbItems"
    :locale="locale"
  >

    <div class="col-xl-8 offset-xl-2">
      <ContactDetailsForm
        :customer="newContact"
        :show-personal-details-header="true"
        :show-id-number="showIdNumber"
        :show-gender="showGender"
        :show-date-of-birth="showBirthDate"
        :show-relationship-type="true"
        :basic-details-card-title="`New ` + this.$t('sidebar.owner')"
        @customer-updated="handleContactCreated"
      />
    </div>
  </PageLayout>
</template>

<script>
import PageLayout from "../layouts/PageLayout.vue";
import ContactDetailsForm from "../ContactDetails/ContactDetailsForm.vue";
import {showWarning} from "../../utils/notification.utils";
import permissionService from "../../service/permission.service";

export default {
  name: "CreateContactPage",
  components: {
    PageLayout,
    ContactDetailsForm
  },
  data() {
    return {
      pageTitle: "Create New Contact",
      locale: this.$i18n.locale,
      breadcrumbItems: [
        {label: 'Home', to: '/dashboard'},
        {label: this.$t('sidebar.owners'), to: '/contacts'},
        {label: `Create ` + this.$t('sidebar.owner'), to: '/contacts/create'}
      ],
      newContact: {
        firstName: "",
        lastName: "",
        idNumber: "",
        emails: [{
          emailAddress: "",
          emailType: "PRIMARY"
        }],
        phones: [{
          countryCode: "263",
          phoneNumber: "",
          phoneType: "MOBILE"
        }],
        addresses: [{
          addressLine1: "",
          addressLine2: "",
          city: "",
          state: "",
          postalCode: "",
          country: "US",
          addressType: "RESIDENTIAL"
        }],
        metadata: [{
          key: "",
          value: ""
        }]
      },
      showIdNumber: false,
      showGender: false,
      showBirthDate: false,
      pagePermissions: ["CUSTOMER_CREATE"]
    };
  },
  methods: {
    handleContactCreated(contact) {
      // Navigate to the contacts list page
      this.$router.push('/contacts');
    }
  },
  async mounted() {
    if (!this.$store.state.auth.user) {
      await this.$router.push("/login");
      return;
    }

    const result = await permissionService.checkPermissions(this.pagePermissions);
    if (!result.success) {
      await showWarning('Error: You do not have permission to create contacts');
      await this.$router.push('/contacts');
    }

    if (['levies', 'school', 'medical'].includes(this.locale)) {
      this.showIdNumber = true;
      this.showGender = true;
      this.showBirthDate = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/contacts/CreateContactPage.vue